let info = {
    "total": [
        {
            name: "Events",
            number: 44,
            color: "#EA4335"
        },
        {
            name: "Workshop",
            number: 7,
            color: "#34A853"
        },
        {
            name: "Members",
            number: 1200,
            color: "#FBBC04"
        },
    ],

};
export default info;